import { ResourceActionsTypes } from '../actions/resource.actions';

const initialState: any = {};

export function ResourceReducer(state: any = initialState, action: any) {
  switch (action.type) {
    case ResourceActionsTypes.UPDATE_RESOURCE:
      return action.payload;
    default:
      return state;
  }
}
